// Tier configuration for usage quotas
// Centralized configuration for easy adjustment

export const TIERS = {
  FREE: {
    name: 'Free',
    costLimit: 1.00,
    videoGenLimit: 1,
    imageGenLimit: 3,
    price: 'Free',
    description: 'Get started with basic AI features'
  },
  PLUS: {
    name: 'Plus',
    costLimit: 5.00,
    videoGenLimit: 5,
    imageGenLimit: 10,
    price: 'Free',
    description: 'Enhanced limits for regular users'
  },
  PREMIUM: {
    name: 'Premium',
    costLimit: 50.00,
    videoGenLimit: 50,
    imageGenLimit: 100,
    price: '$10/month',
    description: 'Maximum limits for power users',
    comingSoon: true
  }
};

// Helper function to get tier config by name
export const getTierConfig = (tierName) => {
  return TIERS[tierName] || TIERS.FREE;
};
